export default __webpack_public_path__ + "static/media/Resources.4f5090f0.svg";